import { Component } from '@angular/core';
import { InsuranceFlexWrapper } from '@app/pages/quote/insurance/insurance-flex/insurance-flex-wrapper.component';
import { ActivatedRoute } from '@angular/router';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';

@Component({
  selector: 'app-insurance-flex-mobile',
  templateUrl: './insurance-flex-mobile.component.html',
  styleUrls: ['./insurance-flex-mobile.component.scss'],
})
export class InsuranceFlexMobileComponent extends InsuranceFlexWrapper {
  constructor(
    route: ActivatedRoute,
    menu: MenusServices,
    notification: NotificationService
  ) {
    super(route, menu, notification);
  }
}
